import { Locale, enUS, ptBR } from 'date-fns/locale';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isPortugueseLanguage } from '../utils/resolveLocale';

export function useDateFnsLocale(): Locale {
  const { i18n } = useTranslation();
  return useMemo(
    () => (isPortugueseLanguage(i18n.language) ? ptBR : enUS),
    [i18n.language],
  );
}
